// extracted by mini-css-extract-plugin
export default {"container":"Modal-module__container--tr8lw","window":"Modal-module__window--pFdYf","header":"Modal-module__header--QyoZI","nav_btn":"Modal-module__nav_btn--rExGO"};